/* eslint-disable arrow-body-style */
import { Modal } from '@mui/material';
import {  StyledSectionModalBox } from '../../styles';
import { Section } from 'src/@types/Course';
import NewSectionForm from 'src/sections/@dashboard/course/NewSectionForm';

export const SectionModal = ({
  open,
  handleClose,
  isEdit,
  currentSection,
  onSubmit,
}: {
  open: boolean;
  handleClose(): void;
  isEdit: boolean;
  currentSection: Section | undefined;
  onSubmit(section: Section): void;
}) => {
  return (
    <Modal open={open} onClose={handleClose}>
      <StyledSectionModalBox sx={{ width: '50%' }}>
        <NewSectionForm
          isEdit={isEdit}
          currentSection={currentSection}
          onSubmit={onSubmit}
        />
      </StyledSectionModalBox>
    </Modal>
  );
};
